(function () {
  var MODAL_SELECTOR = '[id^="CustomGalleryModal-"]';
  var OPEN_ATTR = 'data-open';
  var BODY_OPEN_CLASS = 'custom-gallery-modal-open';
  var GAP = 0;
  var _touchStartX = 0;
  var _touchStartY = 0;
  var _wasTouchSwipe = false;
  var _SWIPE_THRESHOLD = 10;
  var _SCROLL_COOLDOWN = 300;

  function getModal(sectionId) {
    var id = sectionId ? 'CustomGalleryModal-' + sectionId : null;
    if (id) return document.getElementById(id);
    return document.querySelector(MODAL_SELECTOR);
  }

  function getCarousel(modal) {
    var id = modal.getAttribute('data-carousel-id');
    return id ? document.getElementById(id) : modal.querySelector('.custom-gallery-modal__carousel');
  }

  function scrollThumbIntoView(modal, index) {
    var thumb = modal.querySelector('[data-custom-gallery-thumb][data-index="' + index + '"]');
    if (thumb) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function markSlideLoaded(slide) {
    if (slide && !slide.classList.contains('is-loaded')) slide.classList.add('is-loaded');
  }

  function bindSlidePlaceholder(modal) {
    if (modal._placeholderBound) return;
    modal._placeholderBound = true;
    modal.querySelectorAll('.custom-gallery-modal__slide img').forEach(function (img) {
      if (img.complete) markSlideLoaded(img.closest('.custom-gallery-modal__slide'));
      else img.addEventListener('load', function () { markSlideLoaded(img.closest('.custom-gallery-modal__slide')); });
    });
  }

  var bodyScrollLockListening = false;

  function handleBodyTouchMove(e) {
    var openModalEl = document.querySelector('.custom-gallery-modal[data-open="true"]');
    if (!openModalEl) return;
    if (e.target.closest('.custom-gallery-modal')) return;
    e.preventDefault();
  }

  function lockBodyScroll() {
    document.documentElement.classList.add(BODY_OPEN_CLASS);
    if (!bodyScrollLockListening) {
      bodyScrollLockListening = true;
      document.addEventListener('touchmove', handleBodyTouchMove, { passive: false, capture: true });
    }
  }

  function unlockBodyScroll() {
    document.documentElement.classList.remove(BODY_OPEN_CLASS);
    if (!document.querySelector('.custom-gallery-modal[data-open="true"]')) {
      bodyScrollLockListening = false;
      document.removeEventListener('touchmove', handleBodyTouchMove, { capture: true });
    }
  }

  function openModal(modal, slideIndex) {
    if (!modal) return;
    modal.setAttribute(OPEN_ATTR, 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_OPEN_CLASS);
    lockBodyScroll();
    bindSlidePlaceholder(modal);

    var carousel = getCarousel(modal);
    var track = modal.querySelector('.custom-gallery-modal__track');
    var slides = modal.querySelectorAll('.custom-gallery-modal__slide');
    var thumbs = modal.querySelectorAll('[data-custom-gallery-thumb]');
    var prevBtn = modal.querySelector('[data-prev]');
    var nextBtn = modal.querySelector('[data-next]');
    var total = slides.length;
    if (total === 0) return;

    function getStep() {
      if (!slides.length) return 0;
      return slides[0].offsetWidth + GAP;
    }

    var _navTargetIndex = null;

    function syncFromScroll() {
      if (!carousel || !slides.length) return;
      modal._lastScrollTime = Date.now();
      var step = getStep();
      if (step <= 0) return;
      var scrollLeft = carousel.scrollLeft;
      var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      var scrollCurrent = maxScroll <= 0 ? 0 : Math.min(total - 1, Math.round(scrollLeft / step));
      var current = (_navTargetIndex !== null) ? _navTargetIndex : scrollCurrent;
      if (scrollCurrent === _navTargetIndex) _navTargetIndex = null;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
      });
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
      if (current !== modal._galleryLastIndex) {
        var previousIndex = modal._galleryLastIndex;
        if (typeof previousIndex === 'number' && previousIndex >= 0 && slides[previousIndex]) {
          pauseSlideMedia(slides[previousIndex]);
          if (modal._zoomOutSlide) modal._zoomOutSlide(slides[previousIndex]);
        }
        modal._galleryLastIndex = current;
        scrollThumbIntoView(modal, current);
      }
    }

    function goToSlide(index) {
      index = Math.max(0, Math.min(total - 1, index));
      _navTargetIndex = index;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= total - 1;
      scrollThumbIntoView(modal, index);
      var step = getStep();
      carousel.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    if (!modal._galleryBound) {
      modal._galleryBound = true;
      if (carousel) carousel.addEventListener('scroll', syncFromScroll);
      window.addEventListener('resize', syncFromScroll);
      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (!carousel) return;
        var current = modal._galleryLastIndex || 0;
        if (current <= 0) return;
        goToSlide(current - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (!carousel) return;
        var current = modal._galleryLastIndex || 0;
        if (current >= total - 1) return;
        goToSlide(current + 1);
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = parseInt(t.getAttribute('data-index'), 10);
          goToSlide(idx);
        });
      });
      (function setupZoomPan() {
        var ZOOM_SCALE = 2;
        var SCROLL_CHANGE_THRESHOLD = 8;
        var currentZoomedSlide = null;
        var justPanned = false;
        var carouselScrollAtPointerStart = 0;

        // Touch panning state
        var touchPanning = false;
        var touchPanStartX = 0;
        var touchPanStartY = 0;
        var touchOriginStartX = 50;
        var touchOriginStartY = 50;

        function clamp(val, min, max) {
          return Math.max(min, Math.min(max, val));
        }

        function getOriginPercent(slide) {
          return {
            x: parseFloat(slide.dataset.originX) || 50,
            y: parseFloat(slide.dataset.originY) || 50
          };
        }

        function setOrigin(slide, img, ox, oy) {
          ox = clamp(ox, 0, 100);
          oy = clamp(oy, 0, 100);
          slide.dataset.originX = ox;
          slide.dataset.originY = oy;
          img.style.transformOrigin = ox + '% ' + oy + '%';
        }

        function zoomIn(slide, img, e) {
          slide.classList.add('is-zoomed');
          var ox = 50, oy = 50;
          if (e) {
            var rect = img.getBoundingClientRect();
            var cx = (e.touches && e.touches.length) ? e.touches[0].clientX : e.clientX;
            var cy = (e.touches && e.touches.length) ? e.touches[0].clientY : e.clientY;
            ox = clamp(((cx - rect.left) / rect.width) * 100, 0, 100);
            oy = clamp(((cy - rect.top) / rect.height) * 100, 0, 100);
          }
          slide.dataset.originX = ox;
          slide.dataset.originY = oy;
          img.style.transformOrigin = ox + '% ' + oy + '%';
          img.style.transform = 'scale(' + ZOOM_SCALE + ')';
          currentZoomedSlide = slide;
        }

        function zoomOut(slide, img) {
          slide.classList.remove('is-zoomed');
          img.style.transform = '';
          if (currentZoomedSlide === slide) currentZoomedSlide = null;
          setTimeout(function () {
            if (!slide.classList.contains('is-zoomed')) {
              img.removeAttribute('style');
              delete slide.dataset.originX;
              delete slide.dataset.originY;
            }
          }, 600);
        }

        // Desktop: mouse hover over zoomed image moves the viewport
        document.addEventListener('mousemove', function (e) {
          if (!currentZoomedSlide) return;
          if (!modal.contains(e.target)) return;
          var visibleIndex = modal._galleryLastIndex;
          if (slides[visibleIndex] !== currentZoomedSlide) return;
          var slide = currentZoomedSlide;
          var img = slide.querySelector(':scope > img');
          if (!img) return;
          var rect = slide.getBoundingClientRect();
          var ox = ((e.clientX - rect.left) / rect.width) * 100;
          var oy = ((e.clientY - rect.top) / rect.height) * 100;
          setOrigin(slide, img, ox, oy);
        });

        // Mobile touch: drag to pan the viewport
        function onTouchStart(e) {
          var slide = e.target.closest('.custom-gallery-modal__slide');
          if (!slide || slide.classList.contains('custom-gallery-modal__slide--video')) return;
          if (carousel) carouselScrollAtPointerStart = carousel.scrollLeft;
          if (!slide.classList.contains('is-zoomed')) return;
          touchPanning = false;
          justPanned = false;
          var coords = e.touches[0];
          touchPanStartX = coords.clientX;
          touchPanStartY = coords.clientY;
          var origin = getOriginPercent(slide);
          touchOriginStartX = origin.x;
          touchOriginStartY = origin.y;
        }

        function onTouchMove(e) {
          if (!currentZoomedSlide || !currentZoomedSlide.classList.contains('is-zoomed')) return;
          var slide = currentZoomedSlide;
          var img = slide.querySelector(':scope > img');
          if (!img) return;
          var coords = e.touches[0];
          var dx = coords.clientX - touchPanStartX;
          var dy = coords.clientY - touchPanStartY;
          if (!touchPanning) {
            if (Math.sqrt(dx * dx + dy * dy) > 10) {
              touchPanning = true;
              img.classList.add('is-panning');
            } else {
              return;
            }
          }
          if (e.cancelable) e.preventDefault();
          justPanned = true;
          // Drag right → show left side (decrease origin x)
          var sensitivity = 100 / slide.offsetWidth;
          var ox = touchOriginStartX - dx * sensitivity;
          var oy = touchOriginStartY - dy * sensitivity;
          setOrigin(slide, img, ox, oy);
        }

        function onTouchEnd() {
          if (touchPanning && currentZoomedSlide) {
            var img = currentZoomedSlide.querySelector(':scope > img');
            if (img) img.classList.remove('is-panning');
          }
          touchPanning = false;
        }

        document.addEventListener('touchmove', onTouchMove, { passive: false });
        document.addEventListener('touchend', onTouchEnd);

        slides.forEach(function (slide) {
          if (slide.classList.contains('custom-gallery-modal__slide--video')) return;
          var img = slide.querySelector(':scope > img');
          if (!img) return;
          slide.addEventListener('touchstart', onTouchStart, { passive: false });
          slide.addEventListener('mousedown', function () {
            if (carousel) carouselScrollAtPointerStart = carousel.scrollLeft;
          });
          slide.addEventListener('click', function (e) {
            if (e.target.closest('button') || e.target.closest('[data-custom-gallery-close]')) return;
            if (slide.classList.contains('custom-gallery-modal__slide--video')) return;
            if (justPanned) {
              justPanned = false;
              return;
            }
            if (carousel && Math.abs(carousel.scrollLeft - carouselScrollAtPointerStart) > SCROLL_CHANGE_THRESHOLD) {
              return;
            }
            if (Date.now() - (modal._lastScrollTime || 0) < _SCROLL_COOLDOWN) return;
            if (_wasTouchSwipe) return;
            if (slide.classList.contains('is-zoomed')) {
              zoomOut(slide, img);
            } else {
              zoomIn(slide, img, e);
            }
          });
        });

        modal._zoomOutSlide = function (slide) {
          var im = slide && slide.querySelector(':scope > img');
          if (im && slide.classList.contains('is-zoomed')) zoomOut(slide, im);
        };
      })();
    }

    slideIndex = Math.max(0, Math.min(slideIndex, total - 1));
    modal._galleryLastIndex = slideIndex;
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === slideIndex); });

    function applyOpenScroll() {
      var step = getStep();
      if (carousel && step > 0) {
        carousel.scrollLeft = slideIndex * step;
      }
      syncFromScroll();
      scrollThumbIntoView(modal, slideIndex);
    }

    if (carousel) {
      applyOpenScroll();
      requestAnimationFrame(function () {
        applyOpenScroll();
      });
    }

    var currentSlide = slides[slideIndex];
    if (currentSlide && currentSlide.classList.contains('custom-gallery-modal__slide--video')) {
      var deferred = currentSlide.querySelector('deferred-media');
      if (deferred) {
        loadModalDeferredVideo(deferred);
        setTimeout(function () {
          var iframe = deferred.querySelector('iframe.js-youtube');
          if (iframe && iframe.contentWindow) {
            try {
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } catch (err) {}
          }
          var vimeo = deferred.querySelector('iframe.js-vimeo');
          if (vimeo && vimeo.contentWindow) {
            try {
              vimeo.contentWindow.postMessage('{"method":"play"}', '*');
            } catch (err) {}
          }
        }, 350);
      }
    }

    var closeBtn = modal.querySelector('.custom-gallery-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function pauseSlideMedia(container) {
    if (!container) return;
    container.querySelectorAll('video').forEach(function (v) {
      v.pause();
    });
    container.querySelectorAll('iframe.js-youtube').forEach(function (iframe) {
      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        }
      } catch (err) {}
    });
    container.querySelectorAll('iframe.js-vimeo').forEach(function (iframe) {
      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      } catch (err) {}
    });
    container.querySelectorAll('product-model').forEach(function (model) {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  function pauseModalMedia(modal) {
    if (!modal) return;
    pauseSlideMedia(modal);
  }

  function closeModal(modal) {
    if (!modal) return;
    pauseModalMedia(modal);
    modal.setAttribute(OPEN_ATTR, 'false');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_OPEN_CLASS);
    unlockBodyScroll();
  }

  function handleOpenClick(e) {
    var trigger = e.target.closest('[data-custom-gallery-open]');
    console.log('[handleOpenClick] trigger:', trigger, 'target:', e.target);
    if (!trigger) return;
    if (_wasTouchSwipe) { console.log('[handleOpenClick] blocked by wasTouchSwipe'); return; }
    var sectionId = trigger.getAttribute('data-section-id');
    var slideIndex = parseInt(trigger.getAttribute('data-slide-index'), 10) || 0;
    var modal = getModal(sectionId);
    console.log('[handleOpenClick] sectionId:', sectionId, 'slideIndex:', slideIndex, 'modal:', modal);
    openModal(modal, slideIndex);
  }

  function handleOpenClickCapture() {
    // Removed – PDP video poster clicks are now handled by direct listeners below
  }

  function handleCloseClick(e) {
    var modal = e.target.closest(MODAL_SELECTOR);
    if (!modal || modal.getAttribute(OPEN_ATTR) !== 'true') return;
    if (e.target.closest('[data-custom-gallery-close]')) {
      closeModal(modal);
      return;
    }
    if (e.target === modal || (modal.contains(e.target) && !e.target.closest('.custom-gallery-modal__box'))) {
      closeModal(modal);
    }
  }

  function handleKeydown(e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('.custom-gallery-modal[data-open="true"]');
    if (modal) closeModal(modal);
  }

  document.addEventListener('click', handleOpenClickCapture, true);
  document.addEventListener('click', handleOpenClick);
  document.addEventListener('click', handleCloseClick);
  document.addEventListener('keydown', handleKeydown);

  // Global touch tracking to detect swipes vs taps
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length) {
      _touchStartX = e.touches[0].clientX;
      _touchStartY = e.touches[0].clientY;
      _wasTouchSwipe = false;
    }
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (e.changedTouches && e.changedTouches.length) {
      var dx = Math.abs(e.changedTouches[0].clientX - _touchStartX);
      var dy = Math.abs(e.changedTouches[0].clientY - _touchStartY);
      if (dx > _SWIPE_THRESHOLD || dy > _SWIPE_THRESHOLD) {
        _wasTouchSwipe = true;
        return;
      }
    }
    // Mobile tap: open gallery if tapping on a gallery trigger (click may not fire inside scroll-snap containers)
    var trigger = e.target.closest('[data-custom-gallery-open]');
    if (!trigger || trigger.closest('.custom-gallery-modal')) return;
    e.preventDefault();
    var sectionId = trigger.getAttribute('data-section-id');
    var slideIndex = parseInt(trigger.getAttribute('data-slide-index'), 10) || 0;
    var modal = getModal(sectionId);
    openModal(modal, slideIndex);
  }, { passive: false });

  function loadModalDeferredVideo(deferred) {
    if (!deferred || deferred.getAttribute('loaded')) return;
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    var template = deferred.querySelector('template');
    if (!template || !template.content || !template.content.firstElementChild) return;
    var content = document.createElement('div');
    content.appendChild(template.content.firstElementChild.cloneNode(true));
    var media = content.querySelector('video, model-viewer, iframe');
    if (!media) return;
    deferred.setAttribute('loaded', 'true');
    deferred.appendChild(media);
    var poster = deferred.querySelector('.deferred-media__poster');
    if (poster) {
      poster.style.setProperty('display', 'none', 'important');
      poster.style.setProperty('visibility', 'hidden', 'important');
      poster.setAttribute('aria-hidden', 'true');
    }
    deferred.querySelectorAll('.deferred-media__poster-button').forEach(function (btn) {
      btn.style.setProperty('display', 'none', 'important');
      btn.style.setProperty('visibility', 'hidden', 'important');
    });
    if (media.nodeName === 'VIDEO' && media.getAttribute('autoplay')) {
      media.play().catch(function () {});
    }
  }

  function handleModalPlayIntent(e) {
    var openModalEl = document.querySelector('.custom-gallery-modal[data-open="true"]');
    if (!openModalEl) return;
    var poster = e.target.closest('.deferred-media__poster');
    if (!poster || !openModalEl.contains(poster)) return;
    var deferred = poster.closest('deferred-media');
    if (!deferred || deferred.getAttribute('loaded')) return;
    e.preventDefault();
    e.stopPropagation();
    loadModalDeferredVideo(deferred);
  }

  document.addEventListener('click', handleModalPlayIntent, true);
  document.addEventListener('mousedown', handleModalPlayIntent, true);
  document.addEventListener('touchstart', handleModalPlayIntent, { capture: true, passive: false });

  // Direct click on PDP video poster buttons → open gallery modal
  var videPosters = document.querySelectorAll('deferred-media:not(.custom-gallery-modal__video-wrapper) .deferred-media__poster[data-custom-gallery-open]');
  console.log('[gallery-modal] Found PDP video posters with data-custom-gallery-open:', videPosters.length, videPosters);
  videPosters.forEach(function (poster) {
    poster.addEventListener('click', function (e) {
      console.log('[gallery-modal] DIRECT poster click fired!', poster.id);
      e.preventDefault();
      e.stopImmediatePropagation();
      var sectionId = poster.getAttribute('data-section-id');
      var slideIndex = parseInt(poster.getAttribute('data-slide-index'), 10) || 0;
      var modal = getModal(sectionId);
      console.log('[gallery-modal] sectionId:', sectionId, 'slideIndex:', slideIndex, 'modal found:', !!modal);
      openModal(modal, slideIndex);
    });
  });
})();
